import { appConfig } from '../config/appConfig';

export const IDENTITY_CONFIG = {
  authority: appConfig.authLink,
  client_id: appConfig.clientId,
  redirect_uri: `${window.location.origin}/callback.html`,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  response_type: 'code',
  scope: 'openid profile offline_access email cuc_scope location-profile-api',
  post_logout_redirect_uri: window.location.origin,
};
